import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import Text from 'core/elements/Text'
import generateTestId from 'utils/test-helpers'

interface Props {
  value: string
  label: string
  count?: number
  isActive: boolean
  onClick: (value: string) => void
}

export default function TabPreview({ label, value, isActive, onClick, count }: Props) {
  const classes = useStyles({ isActive })
  return (
    <div className={classes.tabPreview} onClick={() => onClick(value)}>
      <Text
        className={classes.tabText}
        data-testid={generateTestId(label, 'tab')}
        variant="subtitle2"
      >
        {label} {count !== undefined ? `(${count})` : ''}
      </Text>
      {isActive && <span className={classes.activeBorder} />}
    </div>
  )
}

interface StyleProps {
  isActive: boolean
}
const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  tabPreview: {
    height: 35,
    display: 'grid',
    gap: 8,
    gridAutoFlow: 'row',
    cursor: 'pointer',
  },
  tabText: {
    padding: '0 16px',
    color: ({ isActive }) => theme.components.tab[isActive ? 'activeText' : 'text'],
    '&:hover': {
      color: theme.components.tab.activeText,
    },
  },
  activeBorder: {
    height: 4,
    display: 'grid',
    borderRadius: 1.5,
    margin: 0,
    padding: 0,
    background: theme.components.tab.activeBackground,
  },
}))
